/* eslint-disable react/jsx-key */
'use client';

import { createIcon } from '@react/chakra';

export const RubyIcon = createIcon({
  displayName: 'RubyIcon',
  viewBox: '0 0 32 32',
  path: [
    <path
      fill='url(#a)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22.594 19.84 8.892 28l17.742-1.207L28 8.852 22.594 19.84Z'
    />,
    <path
      fill='url(#b)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m26.663 26.78-1.525-10.554-4.154 5.5 5.68 5.055Z'
    />,
    <path
      fill='url(#c)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m26.684 26.78-11.172-.88-6.56 2.077 17.732-1.197Z'
    />,
    <path
      fill='url(#d)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m8.967 27.98 2.79-9.169-6.14 1.317 3.35 7.852Z'
    />,
    <path
      fill='url(#e)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m27.418 11.812-6.947-5.69-1.935 6.272 8.882-.582Z'
    />,
    <path
      fill='url(#f)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m24.168 4.093-4.085 2.265-2.578-2.295 6.663.03Z'
    />,
    <path
      fill='url(#g)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m4 23.203 1.712-3.13-1.385-3.73L4 23.204Z'
    />,
    <path
      fill='#fff'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m4.235 16.226 1.393 3.962 6.053-1.361 6.911-6.44 1.95-6.213L17.472 4 12.25 5.96c-1.645 1.533-4.837 4.569-4.952 4.626-.114.058-2.108 3.837-3.064 5.64Z'
    />,
    <path
      fill='url(#h)'
      d='m11.723 18.788 6.869-6.402.003-.01 2.388 9.38-9.26-2.968Z'
    />,
    <path
      fill='url(#i)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.126 9.108c3.565-3.545 8.16-5.639 9.925-3.855 1.762 1.785-.107 6.121-3.672 9.665-3.565 3.543-8.104 5.753-9.866 3.968-1.764-1.783.048-6.235 3.613-9.778Z'
    />,
    <path
      fill='url(#j)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m8.967 27.976 2.769-9.198 9.196 2.963c-3.325 3.126-7.023 5.77-11.965 6.235Z'
    />,
    <path
      fill='url(#k)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m18.604 12.368 2.36 9.377c2.778-2.928 5.27-6.077 6.492-9.971l-8.852.594Z'
    />,
    <path
      fill='url(#l)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M27.432 11.822c.945-2.86 1.163-6.962-3.293-7.723l-3.656 2.025 6.949 5.698Z'
    />,
    <path
      fill='#9e1209'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 23.162c.13 4.72 3.526 4.79 4.972 4.83l-3.34-7.823L4 23.162Z'
    />,
    <path
      fill='url(#m)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18.617 12.383c2.134 1.315 6.436 3.957 6.523 4.006.136.076 1.855-2.907 2.245-4.593l-8.768.587Z'
    />,
    <path
      fill='url(#n)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m11.732 18.778 3.702 7.162c2.19-1.19 3.903-2.641 5.473-4.195l-9.175-2.967Z'
    />,
    <path
      fill='url(#o)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m5.617 20.178-.524 6.263c.99 1.356 2.351 1.474 3.78 1.368-1.034-2.579-3.098-7.735-3.256-7.63Z'
    />,
    <path
      fill='url(#p)'
      fillRule='evenodd'
      clipRule='evenodd'
      d='m20.462 6.14 7.354 1.034c-.393-1.668-1.598-2.744-3.652-3.08l-3.702 2.045Z'
    />,
    <defs>
      <linearGradient
        id='a'
        x1='25.086'
        x2='20.002'
        y1='30.183'
        y2='21.231'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fb7655' />
        <stop offset='.41' stopColor='#e42b1e' />
        <stop offset='.99' stopColor='#900' />
        <stop offset='1' stopColor='#900' />
      </linearGradient>
      <linearGradient
        id='b'
        x1='27.609'
        x2='21.072'
        y1='22.653'
        y2='18.279'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#871101' />
        <stop offset='.99' stopColor='#911209' />
        <stop offset='1' stopColor='#911209' />
      </linearGradient>
      <linearGradient
        id='c'
        x1='22.388'
        x2='15.852'
        y1='30.454'
        y2='26.08'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#871101' />
        <stop offset='.99' stopColor='#911209' />
        <stop offset='1' stopColor='#911209' />
      </linearGradient>
      <linearGradient
        id='d'
        x1='8.688'
        x2='9.705'
        y1='19.474'
        y2='26.066'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset='.23' stopColor='#e57252' />
        <stop offset='.46' stopColor='#de3b20' />
        <stop offset='.99' stopColor='#a60003' />
        <stop offset='1' stopColor='#a60003' />
      </linearGradient>
      <linearGradient
        id='e'
        x1='21.819'
        x2='22.941'
        y1='7.1'
        y2='11.92'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset='.18' stopColor='#e46342' />
        <stop offset='.4' stopColor='#c82410' />
        <stop offset='.99' stopColor='#a80d00' />
        <stop offset='1' stopColor='#a80d00' />
      </linearGradient>
      <linearGradient
        id='f'
        x1='18.412'
        x2='23.225'
        y1='5.402'
        y2='3.002'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset='.54' stopColor='#c81f11' />
        <stop offset='.99' stopColor='#bf0905' />
        <stop offset='1' stopColor='#bf0905' />
      </linearGradient>
      <linearGradient
        id='g'
        x1='4.473'
        x2='4.871'
        y1='17.794'
        y2='21.766'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset='.31' stopColor='#de4024' />
        <stop offset='.99' stopColor='#bf190b' />
        <stop offset='1' stopColor='#bf190b' />
      </linearGradient>
      <linearGradient
        id='h'
        x1='15.645'
        x2='16.02'
        y1='13.319'
        y2='20.046'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#fff' />
        <stop offset='.23' stopColor='#e4714e' />
        <stop offset='.56' stopColor='#be1a0d' />
        <stop offset='.99' stopColor='#a80d00' />
        <stop offset='1' stopColor='#a80d00' />
      </linearGradient>
      <linearGradient
        id='i'
        x1='1.752'
        x2='20.408'
        y1='22.84'
        y2='3.711'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#bd0012' />
        <stop offset='.07' stopColor='#fff' />
        <stop offset='.17' stopColor='#fff' />
        <stop offset='.27' stopColor='#c82f1c' />
        <stop offset='.33' stopColor='#820c01' />
        <stop offset='.46' stopColor='#a31601' />
        <stop offset='.72' stopColor='#b31301' />
        <stop offset='.99' stopColor='#e82609' />
        <stop offset='1' stopColor='#e82609' />
      </linearGradient>
      <linearGradient
        id='j'
        x1='16.002'
        x2='10.396'
        y1='24.775'
        y2='23.396'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8c0c01' />
        <stop offset='.54' stopColor='#990c00' />
        <stop offset='.99' stopColor='#a80d0e' />
        <stop offset='1' stopColor='#a80d0e' />
      </linearGradient>
      <linearGradient
        id='k'
        x1='25.625'
        x2='20.635'
        y1='18.031'
        y2='13.571'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#7e110b' />
        <stop offset='.99' stopColor='#9e0c00' />
        <stop offset='1' stopColor='#9e0c00' />
      </linearGradient>
      <linearGradient
        id='l'
        x1='27.454'
        x2='24.967'
        y1='9.823'
        y2='7.172'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#79130d' />
        <stop offset='.99' stopColor='#9e120b' />
        <stop offset='1' stopColor='#9e120b' />
      </linearGradient>
      <linearGradient
        id='o'
        x1='7.231'
        x2='5.2'
        y1='27.97'
        y2='21.099'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#8b2114' />
        <stop offset='.43' stopColor='#9e100a' />
        <stop offset='.99' stopColor='#b3100c' />
        <stop offset='1' stopColor='#b3100c' />
      </linearGradient>
      <linearGradient
        id='p'
        x1='22.732'
        x2='27.266'
        y1='5.19'
        y2='7.186'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#b31000' />
        <stop offset='.44' stopColor='#910f08' />
        <stop offset='.99' stopColor='#791c12' />
        <stop offset='1' stopColor='#791c12' />
      </linearGradient>
      <radialGradient
        id='m'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(6.09995 0 0 6.11692 21.423 13.643)'
      >
        <stop stopColor='#a80d00' />
        <stop offset='.99' stopColor='#7e0e08' />
        <stop offset='1' stopColor='#7e0e08' />
      </radialGradient>
      <radialGradient
        id='n'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='matrix(8.10906 0 0 8.13164 12.976 21.704)'
      >
        <stop stopColor='#a30c00' />
        <stop offset='.99' stopColor='#800e08' />
        <stop offset='1' stopColor='#800e08' />
      </radialGradient>
    </defs>,
  ],
});
